import { Component, OnInit } from '@angular/core';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { Acta_expediente } from '../../../models/acta_expediente.model';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { Obs_expediente } from '../../../models/obs_expediente.model';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { from } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { reject } from 'q';
import { FLAGS } from '@angular/core/src/render3/interfaces/view';
import { GLOBAL } from 'src/app/services/global';

declare var jQuery: any;
declare var $: any;

@Component({
    selector: 'page-acta_expediente',
    templateUrl: './acta_expediente.component.html',
    styleUrls: ['./acta_expediente.component.css'],
    providers: [Seguimiento_exp_Service, FormService]
})
export class Acta_expedienteComponent implements OnInit {

    public nombreMuni = GLOBAL.nombreMuni;
    public acta;
    public observac;
    public observ: Obs_expediente[];
    public solic;
    public informacion;
    public exp;

    constructor(private fb: FormBuilder, private _SeguimService: Seguimiento_exp_Service, public dialog: MatDialog, public _formService: FormService, private spinner: NgxSpinnerService, private _route: ActivatedRoute) {
        this.acta = { id_solicitud: '', fecha_acta: null, encabezado: '',  notas: '', notas1: ''};
        this.observ = [{ id: '', observaciones: '', norma: '' }]
    }

    ngOnInit() {
       this.getActa();
    }

    ngAfterViewInit() {

    }

    getActa() {
        this.exp  = JSON.parse(localStorage.getItem("solicitud_exp"));
        this.spinner.show()
        this._SeguimService.getActa(this.exp[0].solicitud).subscribe(
            response => {
                if (response.message) {
                    alert("El número de solicitud que estas buscando no existe en los registros");
                    this.spinner.hide()
                } else {
                    this.acta = response.acta;
                    this.observ = response.observ;
                    this.spinner.hide();
                }
            },
            error => {
               
                this.spinner.hide()
            }
        )
    }

    cleanData() {
        this.acta = { id_solicitud: '', fecha_acta: null, encabezado: '',  notas: '', notas1: ''};
        this.observ = [{ id: '', observaciones: '', norma: '' }]
    }

 
    captureScreen() {
        this.exp  = JSON.parse(localStorage.getItem("solicitud_exp"));
        var pdf
        var imgData
        var totalPages
        pdf = new jsPDF('p', 'mm', 'legal');
        let doc_width = 8.5;  // A4 measures 210 × 297 millimeters or 8.27 × 11.69 inches
        let doc_height = 13.00;
        let aspect = doc_height / doc_width;
        let dpi = 96; // default
        let img_width = doc_width * dpi;
        let img_height = doc_height * dpi;
        let win_width = img_width;
        let win_height = img_height;
        let html2canvasOpts = {
            scale: 1,
            windowHeight: win_height - 3,
            
        };
        let jsPDFOpts = {
            orientation: 'portrait',
            unit: 'in',
            format: [doc_width, doc_height]
        };

        html2pdf().set({
            margin:       [0.50, 0.00, 0.50, 0.00], // [top, left, bottom, right]
            filename:     'Acta '+this.exp[0].solicitud+'.pdf',
            image:        { type: 'jpeg', quality: 0.96 },
            html2canvas:  html2canvasOpts,
            jsPDF:        jsPDFOpts,
            enableLinks:  true,
          }).from( document.getElementById('page1') ).save();
    }
        
    
    
}